module.exports = __webpack_public_path__ + "img/PAT.103c25d4.svg";